<script>
  import {
    Card,
    Accordion,
    Button,
    Text,
    Image,
    Title,
  } from "@svelteuidev/core";
  import Constantes from "../../Classes/Constantes";
  import Conexoes from "../../Classes/Conexoes";
  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
  import CaixaDeDialogo from "../../componentes_basicos/CaixaDeDialogo.svelte";
  import DropDownDB from "../../componentes_basicos/DropDownDB.svelte";
  import { onMount } from "svelte";
  import { permissaoUsuario } from "../../Classes/Stores";
  import TelasAcessoNaoAutorizado from "../TelasAcessoNaoAutorizado.svelte";
  import DropDownDb from "../../componentes_basicos/DropDownDB.svelte";
  const conexao = new Conexoes();

  let isLoading = false;
  export let resultados = [];
  export let params;
  let id_campeonato = params;

  let config_campeonato = {
    api: Constantes.api_consultar_padrao,
    parametros: {
      query_code: "consultar_todos_campeonatos",
    },
    nome_coluna_opcoes: "nome_campeonato",
    nome_coluna_saida: "id",
    filtravel: false,
    itens: "",
  };
  // Agrupar resultados por sigla e nome_prova
  let groupedResults = {};
  async function PegarDados() {
    isLoading = true;
    resultados = [];
    resultados = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: "consulta_ranking_prova",

      id_campeonato: id_campeonato,
    });

    resultados.forEach((result) => {
      const key = `${result.sigla} - ${result.nome_prova}`;
      if (!groupedResults[key]) {
        groupedResults[key] = {};
      }
      if (!groupedResults[key][result.atletas]) {
        groupedResults[key][result.atletas] = [];
      }
      groupedResults[key][result.atletas].push(result);
    });
    isLoading = false;
  }

  onMount(() => {
    if (id_campeonato) {
      PegarDados();
    }
  });

  function RetornaDrops(e) {
    id_campeonato = e.detail.objeto.id;
    PegarDados();
  }
</script>

{#if $permissaoUsuario && $permissaoUsuario.permissoes.includes(Constantes.pode_ver_ranking_detalhado)}
  <br />
  <br />
  <LoadingTela {isLoading} />
  <div class="ranking-container">
    {#if !params}
      <label>Selecione o campeonato</label>
      <DropDownDb config={config_campeonato} on:retorno={RetornaDrops} />
    {/if}
    {#if id_campeonato}
      {#each Object.keys(groupedResults) as prova}
        <div class="prova-title">
          {prova}
        </div>
        <table class="table">
          <thead>
            <tr>
              <th>Posição</th>
              <th>Atletas</th>

              <th>Reps</th>
              <th>Tempo</th>
            </tr>
          </thead>
          <tbody>
            {#each Object.keys(groupedResults[prova]) as atleta, atletaIndex}
              {#each groupedResults[prova][atleta] as result, index}
                <tr>
                  {#if index === 0}
                    <!-- Posição e Atleta só são mostrados na primeira linha -->
                    {#if result.publicar == "0"}
                      <td rowspan={groupedResults[prova][atleta].length}
                        >Aguardando</td
                      >
                    {:else}
                      <td rowspan={groupedResults[prova][atleta].length}
                        >{result.posicao}</td
                      >
                    {/if}
                    <td
                      class="athlete-cell"
                      rowspan={groupedResults[prova][atleta].length}
                    >
                      <div class="athlete-name">{result.atletas}</div>
                      <div>{result.nome_equipe}</div>
                    </td>
                  {/if}
                  {#if result.publicar == "0"}
                    {#if result.cap > 0}
                      <td>Cap + {result.cap}</td>
                    {:else if result.pontuacao}
                      <td>{result.pontuacao}</td>
                    {:else}
                      <td>0</td>
                    {/if}
                  {:else}
                    <td>Aguardando</td>

                   
                  {/if}

                  <td>{result.tempo}</td>
                </tr>
              {/each}
            {/each}
          </tbody>
        </table>
      {/each}
    {/if}
  </div>

  <br />
  <br />
{:else}
  <TelasAcessoNaoAutorizado />
{/if}

<style>
  .ranking-container {
    margin: 20px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 10px;
    background-color: #f9f9f9;
  }

  .prova-title {
    font-size: 1.2em;
    font-weight: bold;
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: left;
    color: #333;
    background-color: #f1f1f1;
    padding: 10px;
    border-radius: 5px;
  }

  .table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }

  .table th,
  .table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }

  .table th {
    background-color: #f2f2f2;
    font-weight: bold;
  }

  .athlete-cell {
    vertical-align: top;
    padding: 10px 5px;
    background-color: #f0f8ff;
  }

  .athlete-cell .athlete-name {
    font-weight: bold;
  }

  .move-details {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .back1 {
    color: gray;
  }
</style>
